import DiscardOption from './DiscardOption/DiscardOption'
import OrderOption from './OrderOption/OrderOption'
import { decisionTypes } from './constants'
import * as Styles from './styles'

const OrderSelector = ({ orders, decision, onLink, onDiscard, orderAlertMessage }) => {
  const isOrderSelected = order => decision?.type === decisionTypes.link && decision.order.id === order.id

  const isDiscardSelected = decision?.type === decisionTypes.discard

  const handleSelectOrder = order => () => onLink(order)

  const handleSelectDiscard = () => onDiscard()

  return (
    <Styles.Container>
      {orders.map(order => (
        <OrderOption
          key={order.id}
          order={order}
          selected={isOrderSelected(order)}
          onClick={handleSelectOrder(order)}
          alertMessage={orderAlertMessage}
        />
      ))}
      <DiscardOption selected={isDiscardSelected} onClick={handleSelectDiscard} />
    </Styles.Container>
  )
}

export default OrderSelector
